import Index from "../components/sections/Index";
import ErrorPage from "../Page404/ErrorPage";
import Wardrobes550 from "../components/offer/Wardrobes550";
import Privacy from "../components/offer/Privacy";

export const privateRoute = [
    {
        path: "/",
        element: <Index />,
    },
    {
        path: "/wardrobes-550",
        element: <Wardrobes550 />,
    },
    {
        path: "/privacy",
        element: <Privacy />,
    },
    {
        path: "/*",
        element: <ErrorPage />,
    },
]